/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router';
import store from '@/store'
import { getCannotAccessList, getDefaultPages } from '@/router/src/access';
import routes from "@/router/src/routes"

import TokenMixin from '@/mixins/TokenMixin'
import UtilsMixin from '@/mixins/UtilsMixin.vue';

Vue.use(VueRouter);
Vue.mixin(TokenMixin);
Vue.mixin(UtilsMixin);

const vm = new Vue();
class router {
  constructor() { }

  init(oI18n, excludeMenuList = [], config) {
    const cannotAccessList = getCannotAccessList(config);
    const defaultPages = getDefaultPages(config);
    
    const genCannotAccessList = (names = [], cannotAccessList) => {
      let list = [];
      if (names.length === 1) {
        list = cannotAccessList[names[0]];
      } else {
        for (let i in names) {
          const l = cannotAccessList[names[i]];
          if (l !== undefined && Array.isArray(l) && l.length > 0) {
            for (let x in l) {
              if (!list.includes(l[x])) {
                list.push(l[x]);
              }
            }
          }
        }
      }
    
      return list || [];
    }

    // remove exclude route
    for (let i = routes.length - 1; i >= 0; i--) {
      if (typeof oI18n?.t === 'function') {
        if (routes[i].meta?.title) {
          routes[i].meta.title = oI18n.t(routes[i].meta.title);
        }
      }

      if (config.VUE_APP_RUN_MODE === 'T27') {
        routes[i].path = routes[i].path.replace('{{studentPrefix}}', 'user');
      } else {
        routes[i].path = routes[i].path.replace('{{studentPrefix}}', 'student');
      }

      if (routes[i].meta && routes[i].meta.prefix) {
        if (config.VUE_APP_RUN_MODE === 'T27') {
          routes[i].meta.prefix = routes[i].meta.prefix.replace('{{studentPrefix}}', 'user');
        } else {
          routes[i].meta.prefix = routes[i].meta.prefix.replace('{{studentPrefix}}', 'student');
        }
      }

      if (routes[i].meta && routes[i].meta.cannotAccess) {
        routes[i].meta.cannotAccess = genCannotAccessList(routes[i].meta.cannotAccess, cannotAccessList);
      }

      let remove = false;
      if (routes[i].meta && routes[i].meta.ref) {
        for (let j = 0; j < routes[i].meta.ref.length; j++) {
          if (excludeMenuList.includes(routes[i].meta.ref[j])) {
            remove = true;
            break;
          }
        }
      }

      if (!remove) {
        if (routes[i].name === 'GradeSetting' && !vm.gEnableCustomGrade
          || ((routes[i].name === 'MonthPassList' || routes[i].name === 'MonthPassDetails' || routes[i].name === 'CreateMonthPass') && !vm.gEnableMonthPass)
          || routes[i].name === 'TutorCalendar' && !vm.isAppMode(['DEV', 'T20'])
          || routes[i].name === 'PointsSetting' && !vm.gEnablePointSystem
          || ((routes[i].name === 'CourseList' || routes[i].name === 'CourseDetails' || routes[i].name === 'CreateCourse') && vm.gEnableAutoGenCourse)
          || ((routes[i].name === 'TutorLeave' || routes[i].name === 'TutorUserLeave') && !vm.gEnableTutorLeave)
          || (routes[i].name === 'UsefulLinks' || routes[i].name === 'FestivalPromotions' || routes[i].name === 'Faq' || routes[i].name === 'Collaborations') && !vm.isAppMode(['T11'])
          || (routes[i].name === 'CouponList' || routes[i].name === 'CouponDetails' || routes[i].name === 'CreateCoupon') && !vm.gEnableCoupon
        ) {
          remove = true;
        }
      }

      if (remove) {
        routes.splice(i, 1);
      }
    }

    const router = new VueRouter({
      mode: 'history',
      base: config.BASE_URL,
      routes
    })
    router.beforeEach(async (to, from, next) => {
      vm.$XHR.restart();
      store.dispatch('toggleLoadingPage', false);
      store.dispatch('setLoading', false);
      store.dispatch('setDataIsUpdated', false);
      store.dispatch('clearConfirmAlertRemind');
      window.scrollTo(0, 0);

      const foundNav = routes.find(el => el.name === to.name);
      let needDefault = !foundNav;
      const userData = vm.gfGetCurrentUserData();
      const isUserLogin = vm.$validate.DataValid(userData) && userData.user_type;

      if (to.meta.requireAuth) {
        if (isUserLogin) {
          if ((to.meta.cannotAccess && to.meta.cannotAccess.includes(userData.user_type))) {
            needDefault = true;
          }
        } else {
          // go to login page
          if (to.meta.isStudent) {
            let link = `/${to.meta.prefix || 'student'}-login`;
            if (to.params && to.params.username) {
              link += `/${to.params.username}`;
            }
            switch (to.name) {
              case 'StudentUserAttendance':
                link += `?next=attendance`;
                break;
              case 'StudentUserOrderList':
                link += `?next=order`;
                break;
              case 'StudentSwitchRequirement':
                link += `?next=requirement`;
                break;
              case 'StudentUserPoints':
                link += `?next=points`;
                break;
            }

            next(link);
          } else {
            next('/login');
          }
          return;
        }
      } else if (to.meta.skipAuth && isUserLogin) {
        needDefault = true;
      }

      if (needDefault) {
        if (isUserLogin) {
          let defaultLink = '';
          if (defaultPages[userData.user_type]) {
            for (let i in defaultPages[userData.user_type]) {
              const foundPageRoute = routes.find(el => el.name === defaultPages[userData.user_type][i]);
              if (foundPageRoute) {
                defaultLink = foundPageRoute.path;
                break;
              }
            }
          }

          if (defaultLink) {
            next(defaultLink);
          }
        } else {
          // page not found
        }
      } else {
        next();
      }
    })

    router.afterEach((to, from) => {
      Vue.nextTick(() => {
        const store = `${config.VUE_APP_NAME}${to.meta.isStudent ? '' : ' CMS'}`;
        to.meta.storeName = store;
        document.title = (`${to.meta.title} - ` || '') + store
      })
    })

    return router;
  }
}

export default new router();
